import React from 'react';

export function wizardProgressPercent(current, total) {
  const safeTotal = Number(total) > 0 ? Number(total) : 1;
  const safeCurrent = Math.min(Math.max(Number(current) || 0, 1), safeTotal);
  return (safeCurrent / safeTotal) * 100;
}

export function wizardProgressLabel(current, total, noun = 'Question') {
  const safeTotal = Number(total) > 0 ? Number(total) : 1;
  const safeCurrent = Math.min(Math.max(Number(current) || 0, 1), safeTotal);
  return `${noun} ${safeCurrent} of ${safeTotal}`;
}

/** Shared Question X of Y bar for every form-generation wizard. */
export default function WizardProgress({ current, total, noun = 'Question' }) {
  return (
    <div className="wizard-progress">
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${wizardProgressPercent(current, total)}%` }}
        />
      </div>
      <span className="progress-text">{wizardProgressLabel(current, total, noun)}</span>
    </div>
  );
}
